export const resolveRouteTenantId = ({ isAdmin, isDistributor, urlTenant, currentTenant }) =>
  (isAdmin || (isDistributor && urlTenant)) ? urlTenant : currentTenant;

export const companyReportPath = ({ isAdmin, isDistributor, tenantId, companyId }) =>
  (isAdmin || (isDistributor && tenantId))
    ? `/tenant-dashboard/${encodeURIComponent(tenantId)}/company/${encodeURIComponent(companyId)}`
    : `/company/${encodeURIComponent(companyId)}`;
